<template>
  <div>
    <div class="modal">
      <heading level="4" class="header">
        <slot name="header">
          {{ t('title') }}
        </slot>

        <icon-button @click="$emit('close')" :aria-label="t('closeButtonAriaLabel')" />
      </heading>
      <div class="modalScrollbar">
        <div class="body">
          <div class="faqItem" v-for="({ question, answer }, index) in questions" :key="index">
            <p class="question">{{ question }}</p>
            <p class="answer">{{ answer }}</p>
          </div>
          <p class="answer">{{ t('notApproved'), }}</p>
          <p class="answer">{{ t('paidInFull'), }}</p>
          <div class="faqItem">
            <p class="question">
              {{ t('additionalQuestion'), }}
            </p>
            <i18n class="answer" path="faqModal.frequentQuestions.additionalInformation">
              <brand-link
                :href="termsLinks.privacyPolicyLink"
                class="policyLink"
                slot="privacyPolicy"
                target="_blank"
                v-text="t('privacyPolicyLinkTitle')"
              />
              <brand-link
                :href="termsLinks.termsOfUseLink"
                class="policyLink"
                slot="termsOfUse"
                target="_blank"
                v-text="t('termsOfUseLinkTitle')"
              />
              <brand-link
                :href="termsLinks.illionTermsOfUseLink"
                class="policyLink"
                slot="illionEndUserTerms"
                target="_blank"
                v-text="t('endUserTermsLinkTitle')"
              />
              <brand-link
                :href="termsLinks.illionPrivacyPolicyLink"
                class="policyLink"
                slot="illionPrivacyPolicy"
                target="_blank"
                v-text="t('privacyPolicyLinkTitle')"
              />
            </i18n>
          </div>
        </div>
      </div>
    </div>
    <div class="backdrop"></div>
  </div>
</template>

<script>
import Heading from '@/components/Heading';

import buildTranslators from '@/utils/build-translators';

export default {
  name: 'faq-modal',

  components: {
    Heading,
  },

  data() {
    return {
      termsLinks: {
        privacyPolicyLink: this.$env.VUE_APP_IDP_PRIVACY_STATEMENT_URL,
        termsOfUseLink: this.$env.VUE_APP_IDP_TERMS_URL,
        illionPrivacyPolicyLink: this.$env.VUE_APP_ILLION_PRIVACY_STATEMENT_URL,
        illionTermsOfUseLink: this.$env.VUE_APP_ILLION_TERMS_OF_USE_URL,
      },
      questions: [
        {
          question: this.$t('faqModal.frequentQuestions.questions.firstQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.firstAnswer'),
        },
        {
          question: this.$t('faqModal.frequentQuestions.questions.secondQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.secondAnswer'),
        },
        {
          question: this.$t('faqModal.frequentQuestions.questions.thirdQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.thirdAnswer'),
        },
        {
          question: this.$t('faqModal.frequentQuestions.questions.forthQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.forthAnswer'),
        },
        {
          question: this.$t('faqModal.frequentQuestions.questions.fifthQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.fifthAnswer'),
        },
        {
          question: this.$t('faqModal.frequentQuestions.questions.sixthQuestion'),
          answer: this.$t('faqModal.frequentQuestions.answers.sixthAnswer'),
        },
      ],
    };
  },

  methods: {
    t(key, options) {
      return buildTranslators('faqModal.frequentQuestions').t(key, options);
    },
  },
};
</script>

<style lang="sass" scoped>
$modal-as-popup-min-height: baseunit(45)

.backdrop
  width: 100vw
  height: 100vh
  position: fixed
  z-index: 1000
  top: 0
  left: 0
  +mq($stego)
    background-color: rgba($color-system-neutral-gray-6, 0.4)

.modal
  width: 100%
  height: 100%
  min-width: baseunit(32)
  position: fixed
  overflow: auto
  z-index: 1001
  top: 0
  left: 0
  background: $color-system-neutral-white
  padding: $glass-spacing-3
  +mq($stego)
    @media(min-height: $modal-as-popup-min-height)
      width: baseunit(75)
      height: auto
      border-radius: 8px
      border: 1px solid $color-system-neutral-white
      overflow: hidden
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      display: flex
      flex-direction: column
  +mq($ankylo)
    width: baseunit(90)
  +mq($tyranno)
    width: baseunit(120)

.modalScrollbar
  +mq($stego)
    @media(min-height: $modal-as-popup-min-height)
      max-height: calc( 100vh - #{baseunit(14.4)} - 96px ) /* screen height - header and footer - fixed offset (not rems) */
      overflow: auto

.header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: $glass-spacing-3

.body
  height: auto

.question
  font-weight: bold
  margin: 0

.answer
  margin-top: 0

.policyLink
  font-weight: bold
  text-decoration: underline

.closeButton
  color: $color-primary-brand-dark
  +font-size(16)
  line-height: 1.25
</style>
